






import Vue from 'vue';
import Component from 'vue-class-component';
import {deleteAd} from '@/clients/UserAdsClient';
import {VueGtag} from 'vue-gtag';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';
import {Prop} from 'vue-property-decorator';

@Component({
  name: 'DeleteAd',
})
export default class DeleteAd extends Vue {
  @Prop({type: String, required: true}) readonly externalId!: string;
  @Prop({type: String, required: true}) readonly auth!: string;

  private deleteClicked(event: Event) {
    event.preventDefault();
    this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ogłoszenie?', {
      title: 'Potwierdź',
      okTitle: 'Tak',
      cancelTitle: 'Nie',
    }).then(yes => {
      if (yes) {
        this.doDelete();
      }
    });
  }

  private doDelete() {
    let success = false;
    deleteAd(this.externalId as string, this.auth as string).then(result => {
      if (result.ok) {
        success = true;
        this.$bvModal.msgBoxOk('Ogłoszenie usunięte');
      } else {
        this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${result.statusText}`);
      }
    }).catch(err => {
      this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${err}`);
    }).finally(() => {
      this.trackDeleteEvent({success});
    });
  }

  private trackDeleteEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('delete', eventParams);
    }
  }
}
